import { Component, Input, TemplateRef, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { FormControl } from '@angular/forms';
import { AsyncTracker } from '@sg/utils';
import { MatDialogRef, MatDialog } from '@angular/material/dialog';
import { SgEntityBasedSession } from '../../misc/entity-based-session';

@Component({
  selector: 'sg-call-me',
  templateUrl: './call-me.component.html',
  styleUrls: ['./call-me.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class SgCallMeComponent implements OnInit {
  @Input() session: SgEntityBasedSession;
  @Input() dialogRef: MatDialogRef<any>;

  phoneFormControl: FormControl;

  callMeState: {
    mode: 'edit' | 'save';
    phoneNumber: string;
    blockMessage: string;
    callResult: string;
    isCallResultError?: boolean;
    tracker: AsyncTracker;
    dialogRef?: MatDialogRef<any>;
    isPhoneValid(phoneNumber: string): boolean;
    editNumber(): void;
    close(): void;
    doCall(): void;
  };

  constructor() {}

  ngOnInit(): void {
    this.phoneFormControl = new FormControl(this.session.user.phoneNumber);
    this.phoneFormControl.disable(); // Start in disabled state (edit mode)

    this.callMeState = {
      mode: 'edit',
      phoneNumber: this.session.user.phoneNumber,
      tracker: new AsyncTracker(),
      blockMessage: '',
      callResult: '',
      dialogRef: this.dialogRef,
      isPhoneValid: (phoneNumber?: string) => {
        if (phoneNumber === undefined) {
          phoneNumber = this.phoneFormControl.value;
        }
        return phoneNumber && phoneNumber.length > 7;
      },
      editNumber: () => {
        if (this.callMeState.mode === 'edit') {
          this.callMeState.mode = 'save';
          this.phoneFormControl.enable();
        } else {
          const phoneNumber = this.phoneFormControl.value;
          this.callMeState.blockMessage = 'Updating phone number';
          this.callMeState.tracker.track(this.session.usersApi.putUsersChangePhoneNumber({ phoneNumber })).then(() => {
            this.callMeState.mode = 'edit';
            this.session.user.phoneNumber = phoneNumber;
            this.phoneFormControl.disable();
            this.callMeState.blockMessage = '';
          });
        }
      },
      close: () => {
        this.callMeState.dialogRef
          .afterClosed()
          .toPromise()
          .then(() => {
            this.callMeState = undefined;
          });
        this.callMeState.dialogRef.close();
      },
      doCall: () => {
        this.callMeState.blockMessage = 'Updating request';
        this.callMeState.tracker
          .track(this.session.usersApi.postUsersCallMe(this.session.currentEntity.id))
          .then(() => {
            this.callMeState.callResult = 'Thank you, we will contact you shortly.';
          })
          .catch((err) => {
            this.callMeState.isCallResultError = true;
            this.callMeState.callResult = 'Sorry, we could not register the call, please try again.';
          });
      },
    };
  }
}
